import React from "react";

const SunLogo = ({ className = "" }) => (
  <svg
    className={`inz-sun ${className}`}
    viewBox="0 0 200 200"
    role="img"
    aria-label="InZoRAH sunrise mark"
  >
    <defs>
      <radialGradient id="inz-core" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFD972" />
        <stop offset="60%" stopColor="#F5A623" />
        <stop offset="100%" stopColor="#FF8A3D" />
      </radialGradient>
      <linearGradient id="inz-halo" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#6C4DF6" stopOpacity="0.18" />
        <stop offset="100%" stopColor="#6C4DF6" stopOpacity="0" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="96" fill="url(#inz-halo)" />
    <g
      className="inz-rays"
      stroke="#F5A623"
      strokeWidth="7"
      strokeLinecap="round"
    >
      <line x1="100" y1="8" x2="100" y2="30" />
      <line x1="100" y1="170" x2="100" y2="192" />
      <line x1="8" y1="100" x2="30" y2="100" />
      <line x1="170" y1="100" x2="192" y2="100" />
      <line x1="35" y1="35" x2="51" y2="51" />
      <line x1="149" y1="149" x2="165" y2="165" />
      <line x1="165" y1="35" x2="149" y2="51" />
      <line x1="51" y1="149" x2="35" y2="165" />
    </g>
    <circle cx="100" cy="100" r="52" fill="url(#inz-core)" />
    <circle
      cx="100"
      cy="100"
      r="52"
      fill="none"
      stroke="#fff"
      strokeOpacity="0.6"
      strokeWidth="2"
    />
  </svg>
);

export const AppleGlyph = () => (
  <svg viewBox="0 0 384 512" aria-hidden="true" className="inz-apple">
    <defs>
      <linearGradient id="inz-apple-silver" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="55%" stopColor="#E6E6EB" />
        <stop offset="100%" stopColor="#B9B9C2" />
      </linearGradient>
    </defs>
    <path
      fill="url(#inz-apple-silver)"
      d="M318.7 268c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-36.1-2.8-75.6 21-89.1 21-14.3 0-49.3-20-76.6-20C61.2 141.2 8 184.2 8 270.3c0 25.4 4.6 51.7 13.9 78.8 12.4 35.7 62.5 123 114.8 121.4 27.3-.7 46.6-19.4 82.1-19.4 34.5 0 52.4 18.8 82.1 18.8 52.8-.8 98-79.8 110.3-115.6-70.4-33.2-92.5-96.1-92.5-86.3zM274 96c26.4-31.3 24-59.8 23.2-70-21 1.2-45.3 14.3-59.1 30.4-15.2 17.3-24.2 38.7-22.3 62.5 22.7 1.8 43.4-9.9 58.2-22.9z"
    />
  </svg>
);

export const PlayGlyph = () => (
  <svg viewBox="0 0 512 512" aria-hidden="true" className="inz-play">
    <defs>
      <linearGradient id="inz-play-blue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00C3FF" />
        <stop offset="100%" stopColor="#0072F5" />
      </linearGradient>
    </defs>
    <path
      fill="url(#inz-play-blue)"
      d="M47 32.7C36.7 43.4 31 58.7 31 78.3v355.4c0 19.6 5.7 34.9 16 45.6l211-223z"
    />
    <path
      fill="#00D95F"
      d="M325 249l-70.6-74.6L74 41.2C82 37 91.6 36.6 102 42.4l257.7 148.3z"
    />
    <path
      fill="#FF3A44"
      d="M325 263l-70.6 74.6L74 470.8c8 4.2 17.6 4.6 28-1.2l257.7-148.3z"
    />
    <path
      fill="#FFCE00"
      d="M463.9 222.8L378 173.2 337.9 256l86 82.8c22-12.9 33.1-27.3 33.1-45.5 0-18.2-11.1-32.6-33.1-45.5z"
    />
  </svg>
);

export default SunLogo;
